import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { CommitmentAvatarGroup } from '../commitment-avatar-group/commitment-avatar-group.tsx';
export enum MakeAPaymentAlertType {
  payAhead,
  paymentDue,
  missingPayment,
}
export interface MakeAPaymentAlertProps {
  alertType: MakeAPaymentAlertType;
  onButtonClick: () => void;
  commitments?: GraphQLCommitment[];
  amountDue?: number;
  className?: string;
}
export const MakeAPaymentAlert = t0 => {
  const $ = _c(29);
  const {
    alertType,
    commitments,
    amountDue,
    className,
    onButtonClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["my", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const variant = alertType === MakeAPaymentAlertType.missingPayment ? "negative" : "neutral";
  const translationKey = MakeAPaymentAlertType[alertType];
  const t2 = `my:makeAPayment.alerts.${translationKey}.title`;
  let t3;
  if ($[1] !== t || $[2] !== t2) {
    t3 = t(t2);
    $[1] = t;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `my:makeAPayment.alerts.${translationKey}.message`;
  let t5;
  if ($[4] !== amountDue || $[5] !== t || $[6] !== t4) {
    t5 = t(t4, {
      amountDue: t("numbers.currencyCustom", {
        amount: amountDue
      })
    });
    $[4] = amountDue;
    $[5] = t;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== alertType || $[9] !== commitments || $[10] !== t || $[11] !== translationKey || $[12] !== variant) {
    t6 = alertType !== MakeAPaymentAlertType.payAhead && commitments && commitments?.length > 0 && <CommitmentAvatarGroup commitments={commitments} purpose={variant} size="lg" tooltipMessage={t(`my:makeAPayment.alerts.${translationKey}.tooltip`, {
      count: commitments.length
    })} />;
    $[8] = alertType;
    $[9] = commitments;
    $[10] = t;
    $[11] = translationKey;
    $[12] = variant;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("my:makeAPayment.alerts.cta");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("my:makeAPayment.alerts.cta");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== onButtonClick || $[19] !== t7 || $[20] !== t8) {
    t9 = <button onClick={onButtonClick} aria-label={t7} type="button">{t8}</button>;
    $[18] = onButtonClick;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== className || $[23] !== t3 || $[24] !== t5 || $[25] !== t6 || $[26] !== t9 || $[27] !== variant) {
    t10 = <Alert className={className} noIcon={true} mobileCentered={true} title={t3} message={t5} middleColumn={t6} variant={variant} buttonAction={t9} />;
    $[22] = className;
    $[23] = t3;
    $[24] = t5;
    $[25] = t6;
    $[26] = t9;
    $[27] = variant;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};